export default __webpack_public_path__ + "static/media/CRTorpedoOpen.15315df0.jpg";